import React from "react";
import { Modal, ModalHeader, ModalBody, Card } from "reactstrap";
import _ from "lodash";
import PlayerGameAccounts from "../Workbench/Banker/player-game-accounts";

function RebateGameAccount(props) {
  const { player, toggleModal } = props;

  return (
    <React.Fragment>
      <Modal
        isOpen={!_.isEmpty(player)}
        role="dialog"
        size="lg"
        autoFocus={true}
        centered={true}
        id="verificationModal"
        tabIndex="-1"
        toggle={toggleModal}
        style={{ maxWidth: "1200px" }}
      >
        <ModalHeader toggle={toggleModal}>Rebate Details</ModalHeader>
        <ModalBody>
          <Card>{player && <PlayerGameAccounts player={player} />}</Card>
        </ModalBody>
      </Modal>
    </React.Fragment>
  );
}

export default RebateGameAccount;
